if (!customElements.get('amazon-buy-button')) {
  customElements.define(
    'amazon-buy-button',
    class AmazonBuyButton extends HTMLElement {
      constructor() {
        super();
        this.variantAmazonUrls = {};
        this.button = null;
        this.section = null;
      }

      connectedCallback() {
        // Get the variant data from the data attribute
        const variantData = this.dataset.variantUrls;
        if (variantData) {
          try {
            this.variantAmazonUrls = JSON.parse(variantData);
          } catch (e) {
            console.error('Failed to parse Amazon variant URLs:', e);
          }
        }

        this.button = this.querySelector('.amazon-buy-button__link');
        this.section = this.querySelector('.amazon-buy-button__container');

        // Subscribe to variant changes using Shopify's pub-sub system
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
        }
      }

      handleVariantChange(event) {
        if (event && event.data && event.data.variant && event.data.variant.id) {
          this.updateButton(event.data.variant.id);
        }
      }

      updateButton(variantId) {
        const amazonUrl = this.variantAmazonUrls[variantId];

        if (amazonUrl && this.button) {
          // Update to available state
          this.button.href = amazonUrl;
          this.button.disabled = false;
          this.button.classList.remove('button--secondary');
          this.button.classList.add('button--primary');
          this.button.textContent = 'Buy on Amazon';
        } else if (this.section) {
          // Update to unavailable state
          this.section.innerHTML = '<button class="button button--full-width button--secondary" disabled>Currently Unavailable</button>';
        }
      }
    }
  );
}
